import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./lib/polyfills";
import { applyShareableURL } from "@ui/lib/urlTools";

console.debug(
  `%cMetroscope ${__PACKAGE_VERSION__}\n%c${process.env["NODE_ENV"]} build %c${__GIT_TAG__} %c#${__GIT_HASH__} (${__GIT_DATE__})`,
  "color: purple;",
  "color: grey;",
  "color: black;",
  "color: grey;",
);

const urlWithoutShareable = applyShareableURL();
if (urlWithoutShareable !== null) {
  window.history.replaceState(null, "", urlWithoutShareable);
}

const rootElement = window.document.getElementById("root");
if (!rootElement) throw new Error("Cannot find root node!");
ReactDOM.createRoot(rootElement).render(<App />);
